<div [id]="wrapperId" [class]="'s_accordion-wrap ' + wrapperClasses">
  @if(accordionCustomHeaderTemplate) {
     <ng-container *ngTemplateOutlet="accordionCustomHeaderTemplate"></ng-container>
  } @else   {
    
    <div [id]="headerId" [class]="headerClasses">
      <button type="button" [id]="id + '-toggle'" class="s_accordion-link link-button" [class.collapsed]="isCollapsed" (click)="toggle()">{{ name }}</button>
      @if(button1) {
        <button (click)="onButton1Click()" [class.s_ico-remove_fill]="isLabelAnIcon" class="link-button extra-button " type="button"  >
          @if(!isLabelAnIcon) {
            {{ button1Label }}
          }</button>
      }
 
      
      @if(accordionDefaultHeaderAdditionalHtml) {
         <ng-container *ngTemplateOutlet="accordionDefaultHeaderAdditionalHtml"></ng-container>
      }        
    </div>
  }

  <div [id]="contentId" class="s_sec-wrap" [collapse]="isCollapsed" [isAnimated]="true">
    
      <ng-content></ng-content>
 
  </div>
</div>
 